import { Stack, Typography } from '@mui/material';
import { objectEntries } from '/@/utils';
import type { TabKey, useSidebarTabs } from '../../tabs';

const ProfileTabs = ({
    title,
    tabs,
    selectedTab,
    setSelectedTab,
}: {
    title: string;
    tabs: ReturnType<typeof useSidebarTabs>[number]['tabs'];
    selectedTab?: TabKey;
    setSelectedTab: (tab: TabKey) => void;
}) => {
    return (
        <Stack py={2.5} pl={4} pr={2} spacing={1.5}>
            <Typography variant='overline' color='primary.mui.inactive' px={2}>
                {title}
            </Typography>
            <Stack px={2} pb={0.5}>
                {objectEntries(tabs).map(([key, tab]) => (
                    <Stack
                        direction='row'
                        key={key}
                        onClick={() => setSelectedTab(key)}
                        p={1}
                        spacing={1.5}
                        alignItems='center'
                        sx={[
                            {
                                cursor: 'pointer',
                            },
                            selectedTab !== key && {
                                '&:hover': {
                                    backgroundColor: 'action.hover',
                                },
                            },
                            selectedTab === key && { background: '#E7F8FF', boxShadow: '-4px 0px 0 0px #00BCFF' },
                        ]}
                    >
                        {tab.icon}
                        <Typography variant='body1' color='primary'>
                            {tab.label}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default ProfileTabs;
